import {  useState,useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux';
import { IoMdClose } from "react-icons/io";
import LoginService from "../../../services/login";
import OtpInput from "../modals/OtpModal";
import { IoIosArrowBack } from "react-icons/io";
import { motion } from "framer-motion";
import axios from "axios";
import { setToken } from "../../../redux/slices/loginSlice";
import { useNavigate } from "react-router";
import ProfileCargoService from "../../../services/ProfileCargo";

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };


export default function CodeStep({phone,setPhone ,onNext,code,setCode,setTokenn,onBack}){
   
    const dispatch=useDispatch()
    const [loading,setLoading]=useState(false)
    const [error, setError] = useState(""); 
    const [time,setTime]=useState(120)
    const [loadingBtn,setLoadingBtn]=useState(false)
    const navigate=useNavigate()
    
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    
    useEffect(()=>{
        if(time<=0) return
    
        const interval=setInterval(() => {
            setTime(prev=>prev-1)
        }, 1000);
    
        return ()=> clearInterval(interval)
    },[time])
    


    function prepareForApi(input) {

          let digits = input.replace(/\D/g, "");
        
   
          if (digits.startsWith("0")) {
            digits = digits.slice(1);
          }
        
          return digits; 
        }


    const handleOtpChange = (value) => {
        setCode(value);
    
      };
      


    const toPersianDigits = (num) =>{
    
        const res=String(num).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
        return res
    }

      function VerifyCodeText({phone}) {
        return (
          <p
            dir="rtl"
            className="text-[16px] text-center text-gray-400  whitespace-normal leading-relaxed w-[330px] "
          >
           یک کد ۵ رقمی از سمت بارسرا بر روی شماره{" "}
            <span dir="ltr" className="font-bold ">{toPersianDigits(phone ? phone :"")}</span>{" "}
            ارسال شد لطفا آن را وارد کنید.
          </p>
        );
      }

      const getProf=async ()=>{

        const profile=await ProfileCargoService.getMyProfile()

        const completionRaw = profile?.data?.data?.Completion;
        return completionRaw
      }


      const sendOtpToApi = async () => {
        setLoadingBtn(true)
        try {
            const num=prepareForApi(phone)

          const body = { 
            mobile:num,
            sentCode:code
           };
          const res = await LoginService.submitOtp(body)
          
          if (res.status==200){
  
            const token=res?.data?.data?.tokens?.accessToken
            axios.defaults.headers.common['Authorization'] = `Bearer ${token || null}`;

            const completionRaw=await getProf()
            const isComplete = completionRaw === true
              || completionRaw === 'true'
              || completionRaw === 1
              || completionRaw === '1';
            
       
            if (isComplete===true) {
              dispatch(setToken(token))
              navigate("/cargo");
            } else {
              setTokenn(token)
              onNext();

            }

          }else{
            setError(res?.data?.message)
          }
          setLoadingBtn(false)
        } catch (err) {
            setLoadingBtn(false)
            setError(err?.data?.data?.message)
        }
      };

      async function handleSendPhoneNumberToDb(){
        try{
  
          const num=prepareForApi(phone)
          const body={
              "mobile":num
          }
          const res=await LoginService.sentOtp(body)
          console.log(res)
          if (res.status==200){
            setTime(120)
          }
         
  
        }catch(err){
        
        }
  
      }

    const pad2 = (n) => String(n).padStart(2, "0");
    return(
        <>  
        <div className="w-full min-h-screen flex flex-col  items-center  justify-center px-5 lg:px-10 overflow-x-hidden">


            <motion.div 
            variants={fadeUp}
            initial="hidden"
            animate="show"
             className="flex flex-col justify-center items-start text-start md:w-[400px] w-full gap-5">
                
                <div className="flex flex-row justify-center w-full h-max text-[25px]">
                {pad2(minutes)}:{pad2(seconds)}
                </div>


              <div dir="ltr" className="flex flex-col items-center w-full justify-center">

                    <VerifyCodeText phone={phone}></VerifyCodeText>

              </div>

          
                <OtpInput onChange={handleOtpChange}></OtpInput>

                {error && (
                    <p className="text-red-500 text-sm mt-1 px-1">
                      {error}
                    </p>
                  )}

                <div className="flex flex-row gap-1 w-full justify-center items-center">

                        <button onClick={sendOtpToApi} className={`md:w-[340px] w-[300px] md:h-[60px] h-[50px] bg-special ${loadingBtn ? "bg-opacity-70" : "bg-opacity-100"}  flex flex-row justify-center items-center text-white rounded-xl`}>
                            <p className="text-[20px]">{loadingBtn ? "منتظر بمانید ..." : "ورود"}</p>
                        </button>

                        <button onClick={onBack} className={`md:w-[60px] w-[50px] md:h-[60px] h-[50px] bg-special ${loadingBtn ? "bg-opacity-70" : "bg-opacity-100"}  flex flex-row justify-center items-center text-white rounded-xl`}>
                            <IoIosArrowBack size={20}></IoIosArrowBack>
                        </button>

                </div>
               

                <div className="flex flex-row items-center justify-start gap-2">
                    <p className="text-gray-400 text-[14px]">کد دریافت نشد ؟  </p>
                    <button onClick={handleSendPhoneNumberToDb} disabled={time!=0} className="text-blue-900 ">ارسال دوباره کد</button>
                </div>
{/* 
                <div className="flex items-center w-full gap-2 mt-4">
                    <input type="checkbox" className="flex-shrink-0" />
                    <p className="lg:text-[15px] text-[12px] text-secondary flex flex-wrap gap-[4px]">
                      با ثبت نام در بارسرا،  
                      <span className="text-primary">شرایط و قوانین</span> و 
                      <span className="text-primary">بیانیه حریم خصوصی</span> را قبول می‌کنم
                    </p>
                </div> */}

            </motion.div>
        </div>



        </>
    )
}